<template>
    <div class="Npoint-box" style="display: none;">
        <div id="Npoint" class="rand" ><a href="javascript:void(0)" @click.stop="snsPointPopup" class="Npoint-btn" title="N포인트 팝업"><img src="/images/img/img-npoint.png" alt="N포인트 적립"></a></div>
    </div>
</template>

<script>
    export default {
        props: {
            sid: String,
        },
        data() {
            return {
                isLogin: false,
                bannerDisplay: 'none',
                arrDisplayValue: ['none', 'block'],
                story_id: this.sid,
                pointId: '',
                point: {},
            };
        },
        created() {
            this.checkEventPeriod ();
            this.checkSnsLogin();
        },
        methods: {
            snsPointPopup () {
                if (this.isLogin) {
                    this.$bus.$emit('open-point-modal-popup', this.pointId); // 포인트팝업
                } else {
                    // this.$bus.$emit('open-sns-login-modal-popup', this.openSnsLoginModalPopup); // 로그인팝업
                    alert('로그인 후 이용하실 수 있습니다.');
                }
            },
            checkSnsLogin () {
                let _this = this;
                axios.get('/api/v1/snslogin/login_info').then(({data}) => {
                    if (data.sns_id != '') {
                        _this.isLogin = true;
                    } else {
                        _this.isLogin = false;
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            displayRandomPosition () {
                /* 랜덤위치 */
                var wrapWidth = document.querySelector('#wrap').clientWidth;
                var wrapHeight = document.querySelector('#wrap').clientHeight;

                var NpointX = Math.floor((Math.random()*wrapWidth - 50));
                var NpointY = Math.floor((Math.random()*wrapHeight - 50));

                $('#Npoint').css('left', NpointX);
                $('#Npoint').css('top', NpointY);

                this.bannerDisplay = this.randomItem(this.arrDisplayValue);
                $('.Npoint-box').css('display', this.bannerDisplay);
            },
            randomItem(a) {
                return a[Math.floor(Math.random() * a.length)];
            },
            checkEventPeriod () {
                axios.get('/api/v1/helper/stampinfo').then(({data}) => {
                    if (data.resultCode == '00') {
                        this.pointId = data.pointId;
                        this.displayRandomPosition();
                        $('.Npoint-box').css('display', 'block');
                    }
                }).catch(err => {
                    console.log(err.response);
                });
            },
//            getPointInfo() {
//                let point_info = {
//                    story_id: this.story_id,
//                    point_id: this.point_id,
//                };
//                let _this = this;
//                axios.get('/api/v1/helper/userpointinfo', {
//                    params: {
//                        story_id: this.story_id,
//                        point_id: this.pointId,
//                    }
//                }).then(({data}) => {
//                    console.log(data);
//                    if (data.resultCode == '99') {
//                        _this.point.point_msg = data.resultMsg;
//                        _this.point_msg = data.resultMsg;
//                        _this.point_name = data.nPointName;
//                        _this.point = data.nPoint;
//                        _this.point_total = data.totPoint;
//                    } else {
//
//
//                    }
//                }).catch(err => {
//                    console.log(err.response);
//                });
//
//                let point_info = {
//                    'message': this.point_msg,
//                    'name': 'aaa',
//                    'point': '10',
//                    'total_point': '100'
//                };
//                console.log(point_info);
//                this.$bus.$emit('open-point-modal-popup', point_info); // 포인트팝업
                //console.log(_this.point);
//            }
        }
    };
</script>